import { render, staticRenderFns } from "./OrganisationWallet.vue?vue&type=template&id=8917a0f8&"
import script from "./OrganisationWallet.vue?vue&type=script&lang=ts&"
export * from "./OrganisationWallet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports